import {configureStore} from '@reduxjs/toolkit';
import authReducer from './auth';
import spinReducer from './spinner'

export const store = configureStore({
    reducer:{
         auth:authReducer,
         spin:spinReducer
    }
})
export const { dispatch, getState } = store; 